import { ApiPath } from '@common/app/api-path';
import {
  type BoostInstantCompleteResponse,
  type BoostRequestAdvertisingType,
  type BoostRequestType,
} from '@common/types/query/boost';

import { type Quarry } from '@/common/types/quarryType';
import { type GetFactoriesListResponse } from '@/common/types/query/factory';
import {
  type ActivateVipStatusBuyLinkResponseType,
  type ActivateVipStatusResponseType,
} from '@/common/types/query/user';
import { type GetWorkshopResponseType } from '@/common/types/query/workshop';

import { api } from '../base';

const boostApi = api.injectEndpoints({
  endpoints: (builder) => ({
    boostPlant: builder.mutation<
      Quarry | GetFactoriesListResponse | GetWorkshopResponseType,
      BoostRequestType
    >({
      query: (body) => ({
        url: ApiPath.BOOST,
        method: 'POST',
        body,
      }),
    }),
    boostPlantAdvertising: builder.mutation<
      Quarry | GetFactoriesListResponse | GetWorkshopResponseType,
      BoostRequestAdvertisingType
    >({
      query: ({ plantType, ...body }) => ({
        url: ApiPath.BOOST_ADVERTISING,
        method: 'POST',
        body,
      }),
    }),
    boostInstantComplete: builder.mutation<
      BoostInstantCompleteResponse,
      { plantId: string }
    >({
      query: ({ plantId }) => ({
        url: ApiPath.BOOST_INSTANT_COMPLETE + plantId,
        method: 'POST',
      }),
    }),
    buyBoostX5X10: builder.mutation<
      | ActivateVipStatusResponseType
      | ActivateVipStatusBuyLinkResponseType
      | void,
      {
        minutes: number;
        currency: 'XTR' | 'TON' | 'free' | 'USDT';
        plantId: string;
      }
    >({
      query: (body) => ({
        url: ApiPath.BOOST + '/boost-for-crypto',
        method: 'POST',
        body,
      }),
    }),
  }),
});

const {
  useBuyBoostX5X10Mutation,
  useBoostPlantMutation,
  useBoostPlantAdvertisingMutation,
  useBoostInstantCompleteMutation,
} = boostApi;

export {
  boostApi,
  useBoostInstantCompleteMutation,
  useBoostPlantAdvertisingMutation,
  useBoostPlantMutation,
  useBuyBoostX5X10Mutation,
};
